const WEEKDAYS: Record<string, string> = {
  Sunday: 'Sun',
  Monday: 'Mon',
  Tuesday: 'Tue',
  Wednesday: 'Wed',
  Thursday: 'Thu',
  Friday: 'Fri',
  Saturday: 'Sat',
};

const MONTHS: Record<string, string> = {
  January: 'Jan',
  February: 'Feb',
  March: 'Mar',
  April: 'Apr',
  May: 'May',
  June: 'Jun',
  July: 'Jul',
  August: 'Aug',
  September: 'Sep',
  October: 'Oct',
  November: 'Nov',
  December: 'Dec',
};

const SCHEDULE_DATE =
  /(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday), (January|February|March|April|May|June|July|August|September|October|November|December) (\d{1,2})(?:st|nd|rd|th)(?:, (\d{4}))?/g;

/** Short label for a schedule string from dates.constants, such as "Wed, Dec 30, 2026". */
export default function shortSclaScheduleDate(value: string): string {
  return value.replace(
    SCHEDULE_DATE,
    (_match, weekday: string, month: string, day: string, year?: string) => {
      const short = `${WEEKDAYS[weekday]}, ${MONTHS[month]} ${Number(day)}`;
      return year ? `${short}, ${year}` : short;
    },
  );
}
